/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M14 18C14 22 16 22 16 22M16 22H17M16 22H8M7 22H8M2 13H22M8 22C8 22 10 21.5 10 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V13.2C22 14.8802 22 15.7202 21.673 16.362C21.3854 16.9265 20.9265 17.3854 20.362 17.673C19.7202 18 18.8802 18 17.2 18H6.8C5.11984 18 4.27976 18 3.63803 17.673C3.07354 17.3854 2.6146 16.9265 2.32698 16.362C2 15.7202 2 14.8802 2 13.2V6.8Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M17.2 2H6.8C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8V13H22V6.8C22 5.11984 22 4.27976 21.673 3.63803C21.3854 3.07354 20.9265 2.6146 20.362 2.32698C19.7202 2 18.8802 2 17.2 2Z"
				fill="currentColor"
			/>
			<path
				d="M14 18C14 22 16 22 16 22M16 22H17M16 22H8M7 22H8M2 13V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18H10M2 13V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V13M2 13H22M22 13V13.2C22 14.8802 22 15.7202 21.673 16.362C21.3854 16.9265 20.9265 17.3854 20.362 17.673C19.7202 18 18.8802 18 17.2 18H10M8 22C8 22 10 21.5 10 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.8 1.25H6.7679H6.76788C5.95505 1.24999 5.29944 1.24999 4.76853 1.29336C4.2219 1.33803 3.74175 1.43239 3.29754 1.65873C2.59193 2.01825 2.01825 2.59193 1.65873 3.29754C1.43239 3.74175 1.33803 4.2219 1.29336 4.76853C1.24999 5.29944 1.24999 5.95505 1.25 6.76788V6.7679V6.8V13V13.2V13.2321V13.2321C1.24999 14.045 1.24999 14.7006 1.29336 15.2315C1.33803 15.7781 1.43239 16.2582 1.65873 16.7025C2.01825 17.4081 2.59193 17.9818 3.29754 18.3413C3.74175 18.5676 4.2219 18.662 4.76853 18.7066C5.29944 18.75 5.95505 18.75 6.76788 18.75H6.8H9.21336C9.09872 19.8631 8.73682 20.4797 8.43944 20.8142C8.25452 21.0223 8.07626 21.1422 7.95529 21.2077C7.92217 21.2257 7.8933 21.2395 7.86976 21.25H7C6.58579 21.25 6.25 21.5858 6.25 22C6.25 22.4142 6.58579 22.75 7 22.75H8L15.9985 22.75L16 22.75H17C17.4142 22.75 17.75 22.4142 17.75 22C17.75 21.5858 17.4142 21.25 17 21.25H16.0221L16.0201 21.2497C16.0048 21.2475 15.9711 21.2415 15.9247 21.226C15.8344 21.1959 15.6887 21.128 15.5303 20.9697C15.2654 20.7047 14.8828 20.099 14.7776 18.75H17.2H17.2321C18.045 18.75 18.7006 18.75 19.2315 18.7066C19.7781 18.662 20.2582 18.5676 20.7025 18.3413C21.4081 17.9818 21.9817 17.4081 22.3413 16.7025C22.5676 16.2582 22.662 15.7781 22.7066 15.2315C22.75 14.7006 22.75 14.045 22.75 13.2321V13.2V13V6.8V6.76788C22.75 5.95505 22.75 5.29944 22.7066 4.76853C22.662 4.2219 22.5676 3.74175 22.3413 3.29754C21.9817 2.59193 21.4081 2.01825 20.7025 1.65873C20.2582 1.43239 19.7781 1.33803 19.2315 1.29336C18.7006 1.24999 18.045 1.24999 17.2321 1.25H17.2321H17.2H6.8ZM9.97426 21.25C10.3411 20.6493 10.6286 19.8375 10.7197 18.75H13.2739C13.3464 19.8396 13.5779 20.6504 13.899 21.25H9.97426ZM17.2 17.25H14H10H6.8C5.94755 17.25 5.35331 17.2494 4.89068 17.2116C4.43681 17.1745 4.17604 17.1054 3.97852 17.0048C3.55516 16.789 3.21095 16.4448 2.99524 16.0215C2.8946 15.824 2.82547 15.5632 2.78838 15.1093C2.7593 14.7534 2.75225 14.3195 2.75054 13.75H21.2495C21.2478 14.3195 21.2407 14.7534 21.2116 15.1093C21.1745 15.5632 21.1054 15.824 21.0048 16.0215C20.789 16.4448 20.4448 16.789 20.0215 17.0048C19.824 17.1054 19.5632 17.1745 19.1093 17.2116C18.6467 17.2494 18.0525 17.25 17.2 17.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14 18C14 22 16 22 16 22M16 22H17M16 22H8M7 22H8M2 13V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18H10M2 13V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V13V13.2C22 14.8802 22 15.7202 21.673 16.362C21.3854 16.9265 20.9265 17.3854 20.362 17.673C19.7202 18 18.8802 18 17.2 18H10M2 13H18M8 22C8 22 10 21.5 10 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 18C14 22 16 22 16 22M16 22H17M16 22H8M7 22H8M2 13V13.2C2 14.8802 2 15.7202 2.32698 16.362C2.6146 16.9265 3.07354 17.3854 3.63803 17.673C4.27976 18 5.11984 18 6.8 18H10M2 13V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H17.2C18.8802 2 19.7202 2 20.362 2.32698C20.9265 2.6146 21.3854 3.07354 21.673 3.63803C22 4.27976 22 5.11984 22 6.8V13M2 13H22M22 13V13.2C22 14.8802 22 15.7202 21.673 16.362C21.3854 16.9265 20.9265 17.3854 20.362 17.673C19.7202 18 18.8802 18 17.2 18H10M8 22C8 22 10 21.5 10 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.65 1.25C5.40979 1.25 4.28969 1.25 3.43404 1.68597C2.68139 2.06947 2.06947 2.68139 1.68597 3.43404C1.25 4.28969 1.25 5.40979 1.25 7.65V14H22.75V7.65C22.75 5.40979 22.75 4.28969 22.314 3.43404C21.9305 2.68139 21.3186 2.06947 20.566 1.68597C19.7103 1.25 18.5902 1.25 16.35 1.25H7.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.75 14C22.75 13.5858 22.4143 13.25 22 13.25C21.5858 13.25 21.25 13.5858 21.25 14H2.75005H2.00005H1.25005L1.25002 14.1158C1.24975 14.9338 1.24957 15.4919 1.37783 15.9706C1.72458 17.2647 2.73538 18.2755 4.02948 18.6222C4.50814 18.7505 5.06629 18.7503 5.88425 18.75H5.88425L6.00005 18.75H9.21341C9.09877 19.8631 8.73687 20.4797 8.43949 20.8142C8.25457 21.0223 8.07631 21.1422 7.95534 21.2077C7.92222 21.2257 7.89335 21.2395 7.86981 21.25H7.00005C6.58584 21.25 6.25005 21.5858 6.25005 22C6.25005 22.4142 6.58584 22.75 7.00005 22.75H8.00005H16H17C17.4143 22.75 17.75 22.4142 17.75 22C17.75 21.5858 17.4143 21.25 17 21.25H16.0222L16.0202 21.2497C16.0049 21.2475 15.9711 21.2415 15.9247 21.226C15.8345 21.1959 15.6888 21.128 15.5304 20.9697C15.2654 20.7047 14.8828 20.099 14.7777 18.75H18L18.1158 18.75C18.9338 18.7503 19.492 18.7505 19.9706 18.6222C21.2647 18.2755 22.2755 17.2647 22.6223 15.9706C22.7505 15.4919 22.7503 14.9338 22.7501 14.1158V14.1158L22.75 14ZM10.7197 18.75H13.274C13.3464 19.8396 13.578 20.6504 13.8991 21.25H9.97431C10.3412 20.6493 10.6286 19.8374 10.7197 18.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
